import PropTypes from 'prop-types';
import { connectToLocale } from '../Locale/Locale';
import SUPPORTED_DATE_TYPES from './SUPPORTED_DATE_TYPES';
import { dateFormat } from './dateFormat';

/**
 * Render a date string based on the current locale.
 */
const Date = ({ context, ...props }) => {
  const locale = props.locale || (context && context.locale) || 'en_US';
  const { date, type, utc } = props;

  return dateFormat({ date, locale, type, utc });
};

export default connectToLocale(Date);

Date.propTypes = {
  context: PropTypes.shape({
    currencyCode: PropTypes.string,
    locale: PropTypes.string,
  }),
  locale: PropTypes.string,
  utc: PropTypes.bool,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  type: PropTypes.oneOf(SUPPORTED_DATE_TYPES),
};

Date.defaultProps = {
  utc: false,
  date: undefined,
  type: SUPPORTED_DATE_TYPES[0],
};
